'use strict';

let processInclude = require('base/util');
require('core/components/spinner');

let updatedPid = '';

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message) {
  let errorHtml =
    '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
    'fade show" role="alert">' +
    '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
    '<span aria-hidden="true">&times;</span>' +
    '</button>' +
    message +
    '</div>';

  $('.cart-error').append(errorHtml);
}

/**
 * replaces the content in the modal window for product variation to be edited.
 * @param {string} editProductUrl - url to be used to retrieve a new product model
 */
function fillModalElement(editProductUrl) {
  $('.modal-body').spinner().start();
  $.ajax({
    url: editProductUrl,
    method: 'GET',
    dataType: 'json',
    success: function (data) {
      updatedPid = data.product ? data.product.id : '';
      document.getElementById('main-overlay').style.display = 'block';
      document.querySelector('body header.header').classList.add('z-index-0');
      document.getElementById('main-overlay').classList.add('no-top');
      document.querySelector('body').style.overflow = 'hidden';
      document.querySelector('body').style.height = '100vh';
      let parsedHtml = parseHtml(data.renderedTemplate);
      $('#editProductModal .modal-body').empty();
      $('#editProductModal .modal-body').html(parsedHtml.body);
      $('#editProductModal .modal-footer').html(parsedHtml.footer);
      $('#editProductModal .modal-header .close .sr-only').text(data.closeButtonText);
      $('#editProductModal .enter-message').text(data.enterDialogMessage);
      $('#editProductModal')[0].classList.add('show');
      document.getElementById('cart-show').style.height = '100%';
      $('body').trigger('editproductmodal:ready');
      bindEventOpenFitGuide();
      $.spinner().stop();
    },
    error: function () {
      $.spinner().stop();
    },
  });
}

/**
 * Finds an element in the array that matches search parameter
 * @param {array} array - array of items to search
 * @param {function} match - function that takes an element and returns a boolean indicating if the match is made
 * @returns {Object|null} - returns an element of the array that matched the query.
 */
function findItem(array, match) {
  for (let i = 0, l = array.length; i < l; i++) {
    if (match.call(this, array[i])) {
      return array[i];
    }
  }
  return null;
}

function getModalHtmlElement() {
  if ($('#editProductModal').length !== 0) {
    $('#editProductModal').remove();
  }
  let htmlString =
    '<!-- Modal -->' +
    '<div class="modal fade" id="editProductModal" role="dialog">' +
    '<div class="edit-modal-container">' +
    '<div class="modal-dialog quick-view-dialog">' +
    '<!-- Modal content-->' +
    '<div class="modal-content">' +
    '<div class="modal-header">' +
    ' <button type="button" class="close pull-right" data-dismiss="modal">' +
    '      <div id="close-edit-product-modal" class="modal-close" role="button" tabindex="0" aria-label="Close dialog" data-dismiss="modal" modal-close></div>' +
    ' </button>' +
    '</div>' +
    '<div class="horizontal-row edit-product-modal-header-bottom"></div>' +
    '<div class="modal-body"></div>' +
    '<div class="modal-footer"></div>' +
    '</div>' +
    '</div>' +
    '</div>' +
    '</div>';
  $('body').append(htmlString);
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
  let $html = $('<div>').append($.parseHTML(html));
  let body = $html.find('.product-quickview');
  let footer = $html.find('.modal-footer').children();

  return { body: body, footer: footer };
}

/**
 * re-renders the approaching discount messages
 * @param {Object} approachingDiscounts - updated approaching discounts for the cart
 */
function updateApproachingDiscounts(approachingDiscounts) {
  let html = '';
  $('.approaching-discounts').empty();
  if (approachingDiscounts.length > 0) {
    approachingDiscounts.forEach(function (item) {
      html += '<div class="single-approaching-discount text-center">' + item.discountMsg + '</div>';
    });
  }
  $('.approaching-discounts').append(html);
}
/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
  $('.number-of-items').empty().append(data.resources.numberOfItems);
  $('.shipping-cost').empty().append(data.totals.totalShippingCost);
  $('.tax-total').empty().append(data.totals.totalTax);
  $('.grand-total').empty().append(data.totals.grandTotal);
  $('.sub-total').empty().append(data.totals.subTotal);
  $('.minicart-quantity').empty().append(data.numItems);
  $('.minicart-link').attr({
    'aria-label': data.resources.minicartCountOfItems,
    title: data.resources.minicartCountOfItems,
  });
  if (data.totals.orderLevelDiscountTotal.value > 0) {
    $('.order-discount').removeClass('hide-order-discount');
    $('.order-discount-total')
      .empty()
      .append('- ' + data.totals.orderLevelDiscountTotal.formatted);
  } else {
    $('.order-discount').addClass('hide-order-discount');
  }

  if (data.totals.shippingLevelDiscountTotal.value > 0) {
    $('.shipping-discount').removeClass('hide-shipping-discount');
    $('.shipping-discount-total')
      .empty()
      .append('- ' + data.totals.shippingLevelDiscountTotal.formatted);
  } else {
    $('.shipping-discount').addClass('hide-shipping-discount');
  }

  data.items.forEach(function (item) {
    if (item.renderedPromotions) {
      $('.item-' + item.UUID)
        .empty()
        .append(item.renderedPromotions);
    }
    if (item.priceTotal && item.priceTotal.renderedPrice) {
      $('.item-total-' + item.UUID)
        .empty()
        .append(item.priceTotal.renderedPrice);
    }
  });
}

/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateAvailability(data, uuid) {
  let lineItem;
  let messages = '';

  for (let i = 0; i < data.items.length; i++) {
    if (data.items[i].UUID === uuid) {
      lineItem = data.items[i];
      break;
    }
  }

  $('.availability-' + lineItem.UUID).empty();

  if (lineItem.availability) {
    if (lineItem.availability.messages) {
      lineItem.availability.messages.forEach(function (message) {
        messages += '<p class="line-item-attributes">' + message + '</p>';
      });
    }

    if (lineItem.availability.inStockDate) {
      messages += '<p class="line-item-attributes line-item-instock-date">' + lineItem.availability.inStockDate + '</p>';
    }
  }

  $('.availability-' + lineItem.UUID).html(messages);
}

/**
 * Updates details of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateProductDetails(data, uuid) {
  let lineItem = findItem(data.cartModel.items, function (item) {
    return item.UUID === uuid;
  });

  if (lineItem.variationAttributes) {
    let colorAttr = findItem(lineItem.variationAttributes, function (attr) {
      return attr.attributeId === 'color';
    });

    if (colorAttr) {
      let colorSelector = '.Color-' + uuid;
      let newColor = 'Color: ' + colorAttr.displayValue;
      $(colorSelector).text(newColor);
    }

    let sizeAttr = findItem(lineItem.variationAttributes, function (attr) {
      return attr.attributeId === 'size';
    });

    if (sizeAttr) {
      let sizeSelector = '.Size-' + uuid;
      let newSize = 'Size: ' + sizeAttr.displayValue;
      $(sizeSelector).text(newSize);
    }

    let imageSelector = '.card.product-info.uuid-' + uuid + ' .item-image > img';
    $(imageSelector).attr('src', lineItem.images.small[0].url);
    $(imageSelector).attr('alt', lineItem.images.small[0].alt);
    $(imageSelector).attr('title', lineItem.images.small[0].title);
  }

  if (lineItem.options && lineItem.options.length) {
    let option = lineItem.options[0];
    let optSelector = '.lineItem-options-values[data-option-id="' + option.optionId + '"]';
    $(optSelector).data('value-id', option.selectedValueId);
    $(optSelector + ' .line-item-attributes').text(option.displayName);
  }

  let qtySelector = '.quantity[data-uuid="' + uuid + '"]';
  $(qtySelector).val(lineItem.quantity);
  $(qtySelector).data('pid', data.newProductId);

  $('.remove-product[data-uuid="' + uuid + '"]').data('pid', data.newProductId);

  let priceSelector = '.line-item-price-' + uuid + ' .sales .value';
  $(priceSelector).text(lineItem.price.sales.formatted);
  $(priceSelector).attr('content', lineItem.price.sales.decimalPrice);

  if (lineItem.price.list) {
    let listPriceSelector = '.line-item-price-' + uuid + ' .list .value';
    $(listPriceSelector).text(lineItem.price.list.formatted);
    $(listPriceSelector).attr('content', lineItem.price.list.decimalPrice);
  }
}

/**
 * Checks whether the basket is valid. if invalid displays error message and disables
 * checkout button
 * @param {Object} data - AJAX response from the server
 */
function validateBasket(data) {
  if (data.valid.error) {
    if (data.valid.message) {
      let errorHtml =
        '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
        'fade show" role="alert">' +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '<span aria-hidden="true">&times;</span>' +
        '</button>' +
        data.valid.message +
        '</div>';

      $('.cart-error').append(errorHtml);
    } else {
      $('.cart')
        .empty()
        .append('<div class="row"> ' + '<div class="col-12 text-center"> ' + '<h1>' + data.resources.emptyCartMsg + '</h1> ' + '</div> ' + '</div>');
      $('.number-of-items').empty().append(data.resources.numberOfItems);
      $('.minicart-quantity').empty().append(data.numItems);
      $('.minicart-link').attr({
        'aria-label': data.resources.minicartCountOfItems,
        title: data.resources.minicartCountOfItems,
      });
      $('.minicart .popover').empty();
      $('.minicart .popover').removeClass('show');
    }

    $('.checkout-btn').addClass('disabled');
  } else {
    $('.checkout-btn').removeClass('disabled');
  }
}

function updateWishlistButton(element, inWishlist) {
  $(element)
    .closest('.edit-modal-container')
    .find('button.js_add-to-wish-list')
    .each(function (i, e) {
      $(e).toggleClass('active', inWishlist);
      $(e).attr('data-pid', updatedPid);
    });
}

function bindEventOpenFitGuide() {
  $('.size-guidelines-button').on('click', function (e) {
    let url = e.currentTarget.dataset['getcontent'];
    if (url) {
      $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success: function (data) {
          if (data) {
              $('#unit-measure_0').trigger('click');
              if (data.sizeListImageUrl) {
                $('.measuring-img__sketches')
                  .empty()
                  .append('<img src="' + data.sizeListImageUrl + '" alt="img" class="single-image-product" />');
              }
              if (data.sizeListOptions == "<option value=\"uni\">UNI</option>") {
                $('.fitguide__container--desktop').addClass('size-uni-active');
              }
              if (data.sizeListOptions) {
                $("select[name='choose-your-size']")
                  .empty()
                  .append(data.sizeListOptions);
              }
              if (data.tableDetails) {
                $('.measuring-guide__size-table .row')
                  .empty()
                  .append(data.tableDetails);
                $('#fitguide-content-01')
                  .css('display' , 'block');

                if($('#fitguide-measurement-button').length > 0) {
                  $('#fitguide-measurement-button')
                    .trigger('click');
                }
                $('#fitguide-measurement-button')
                  .addClass('fitguide__tab-button--active')
                  .closest('.tab-button')
                  .css('display' , 'flex');

                  let selectedSizeCart = $('.size-values li.swatch-attribute-value.selected').length ? $('.size-values li.swatch-attribute-value.selected').attr('data-attr-value').replace(/&nbsp;/g, '').toLowerCase() : '';
                  if(selectedSizeCart !== '' && $("#choose-your-size option[value='" + selectedSizeCart + "']").length > 0) {
                    $("select[name='choose-your-size']")
                    .val(selectedSizeCart)
                    .trigger('change');
                  }
                  
                if (!data.fitGuideContentAsset) {
                  $('#fitguide-measurement-button')
                    .closest('.tab-button')
                    .siblings('.empty-col')
                    .addClass('col-md-12')
                    .css('border-left' , '0');
                  $('.click-to-convert-sizes')
                    .css('display' , 'none');
                }
              }
              if (data.fitGuideContentAsset) {
                $('.measuring-guide-container')
                  .empty()
                  .append(data.fitGuideContentAsset);
                $('#fitguide-sizes-button')
                  .closest('.tab-button')
                  .css('display' , 'flex');
                if (!data.tableDetails) {
                  $('#fitguide-sizes-button')
                    .addClass('fitguide__tab-button--active')
                    .closest('.tab-button')
                    .siblings('.empty-col')
                    .addClass('col-md-10');
                  $('#fitguide-content-02')
                    .css('display' , 'block');
                } 
              }
            }
        },
        error: (error) => {
          alert('error');
        },
      });
    }
  });
}

$(document).ready(function () {
  processInclude(require('core/cart/coupon'));
  processInclude(require('tealium/tealiumEvents'));
  processInclude(require('adobeTarget/loadRecommendations'));
  processInclude(require('./product/productCarousel'));
  processInclude(require('core/product/fitguide'));

  const dutiesTooltipBox = document.querySelector('.tooltip-global-container .duties-tooltip-box');
  const taxesTooltipBox = document.querySelector('.tooltip-global-container .taxes-tooltip-box');
  $('.tooltip-global-container .duties-tooltip-toggler').on('mouseover', () => dutiesTooltipBox.classList.add('visible'));
  $('.tooltip-global-container .duties-tooltip-toggler').on('mouseleave', () => dutiesTooltipBox.classList.remove('visible'));
  $('.tooltip-global-container .taxes-tooltip-toggler').on('mouseover', () => taxesTooltipBox.classList.add('visible'));
  $('.tooltip-global-container .taxes-tooltip-toggler').on('mouseleave', () => taxesTooltipBox.classList.remove('visible'));

  let clickedProduct = '';
  let clickedSize = '';

  $('body').on('click', '.cart-body-section .cart-edit-link', function (e) {
    const $product = $(e.currentTarget);
    clickedProduct = e.currentTarget.parentNode.parentNode.parentNode.parentNode.parentNode.classList[2];
    clickedSize = $(e.currentTarget).parent().find('span.bag-product__details-value').text();
    e.preventDefault();
    const pid = $(this).parent().find('.cart-remove-btn').data('pid');
    let editProductUrl = $(this).attr('href');

    if (pid) {
      editProductUrl += '&pid=' + pid;
    }

    let errorObj = document.querySelector('.cart-error-messaging');
    if (errorObj) document.querySelector('.cart-error-messaging').classList.add('d-none');

    $.ajax({
      url: editProductUrl,
      type: 'GET',
      dataType: 'json',
      data: $product.serialize(),
      beforeSend: function () {
        $.spinner().start();
      },
      success: function (data) {
        if (data.error) {
          $('.promo-code-form .form-control').addClass('is-invalid');
          $product.find('.invalid-feedback').append(data.errorMessage).removeClass('d-none');
        } else {
          // Tealium event "Modify Prodcut Popup Open"
          $('body').trigger('cart:modifyProductOpen');
          getModalHtmlElement();
          fillModalElement(editProductUrl);
        }

        // $('.coupon-code-field').val('');//
        $.spinner().stop();

        setTimeout(function () {
          $('.coupon-code-field').val('');
          $('.promo-code-form .form-control').removeClass('is-valid');
          $('.promo-code-form .form-control').removeClass('is-invalid');
        }, 2000);
      },
      error: function (err) {
        if (err.responseJSON.redirectUrl) {
          window.location.href = err.responseJSON.redirectUrl;
        } else {
          createErrorNotification(err.errorMessage);
          $.spinner().stop();
        }
      },
    });
  });

  $('body').on('change', '#editProductModal select[name=product-variation-attribute]', (e) => {
    e.preventDefault();
    const optionClicked = $('#editProductModal select[name=product-variation-attribute] option:selected')[0];
    clickedSize = optionClicked.dataset.displayvalue;
    const sizePidUrl = optionClicked.dataset.url;
    
    if (sizePidUrl) {
      $.ajax({
        url: sizePidUrl,
        type: 'get',
        context: this,
        dataType: 'json',
        success: function (data) {
          updatedPid = data.product.id;
          updateWishlistButton(e.target, data.product.inWishList);
          $.spinner().stop();
        },
        error: function (err) {
          if (err.responseJSON.redirectUrl) {
            window.location.href = err.responseJSON.redirectUrl;
          } else {
            createErrorNotification(err.responseJSON.errorMessage);
            $.spinner().stop();
          }
        },
      });
    }
  });


  // $('body').on('click', '#editProductModal .swatch-attribute-value', (e) => {
  //   e.preventDefault();
  //   clickedSize = e.currentTarget.dataset.attrDisplayValue;
  //   const $product = $(e.currentTarget);
  //   const sizePidUrl = e.target.dataset.url;
  //   document.querySelectorAll('#editProductModal .swatch-attribute-value').forEach((val) => val.classList.remove('selected'));
  //   e.target.classList.add('selected');
  //   if (sizePidUrl) {
  //     $.ajax({
  //       url: sizePidUrl,
  //       type: 'get',
  //       context: this,
  //       dataType: 'json',
  //       success: function (data) {
  //         updatedPid = data.product.id;
  //         updateWishlistButton(e.target, data.product.inWishList);
  //         $.spinner().stop();
  //       },
  //       error: function (err) {
  //         if (err.responseJSON.redirectUrl) {
  //           window.location.href = err.responseJSON.redirectUrl;
  //         } else {
  //           createErrorNotification(err.responseJSON.errorMessage);
  //           $.spinner().stop();
  //         }
  //       },
  //     });
  //   }
  // });

  $('body').on('click', '.update-cart-product-global', function (e) {
    e.preventDefault();
    let updateProductUrl = $(this).closest('.cart-and-ipay').find('.update-cart-url').val();
    let selectedQuantity = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('selected-quantity');
    let selectedOptionValueId = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('selected-option');
    let uuid = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('uuid');
    let pid = updatedPid;

    let form = {
      uuid: uuid,
      pid: pid,
      quantity: selectedQuantity,
      selectedOptionValueId: selectedOptionValueId,
    };

    $(this).parents('.card').spinner().start();
    if (updateProductUrl) {
      $.ajax({
        url: updateProductUrl,
        type: 'post',
        context: this,
        data: form,
        dataType: 'json',
        success: function (data) {
          document.querySelector('.alert-danger.invalid-selected-product') ? document.querySelector('.alert-danger.invalid-selected-product').classList.add('hidden') : null;
          document.getElementById('editProductModal').classList.remove('show');
          document.getElementById('main-overlay').style.display = 'none';
          document.querySelector('body header.header').classList.remove('z-index-0');
          document.getElementById('cart-show').style.height = '100vh';
          document.getElementById('cart-show').style.overflow = 'auto';
          $('.coupons-and-promos').empty().append(data.cartModel.totals.discountsHtml);
          updateCartTotals(data.cartModel);
          updateApproachingDiscounts(data.cartModel.approachingDiscounts);
          updateAvailability(data.cartModel, uuid);
          updateProductDetails(data, uuid);

          let el = $('.productuuid-' + uuid).find("input[name='quantity']");
          el.attr('data-pid', data.newProductId);

          if (data.uuidToBeDeleted) {
            $('.uuid-' + data.uuidToBeDeleted).remove();
          }

          validateBasket(data.cartModel);
          $('.' + clickedProduct + ' .detail-attribute.size .bag-product__details-value').text(clickedSize);
          $('body').trigger('cart:update');
          document.getElementById('main-overlay').classList.remove('no-top');

          // Tealium event "Modify Product Confirm"
          $('body').trigger('cart:productModified', data);
          $.spinner().stop();
        },
        error: function (err) {
          if (err.responseJSON.redirectUrl) {
            window.location.href = err.responseJSON.redirectUrl;
          } else {
            document.querySelector('.alert-danger.invalid-selected-product').classList.remove('hidden');
            createErrorNotification(err.responseJSON.errorMessage);
            $.spinner().stop();
          }
        },
      });
    }
  });

  $('body').on('click', '#close-edit-product-modal', () => {
    document.getElementById('editProductModal').classList.remove('show');
    document.getElementById('main-overlay').style.display = 'none';
    document.querySelector('body header.header').classList.remove('z-index-0');
    document.querySelector('body').style.overflow = 'auto';
    document.querySelector('body').style.position = 'none';

    let html = document.getElementsByTagName('body')[0];
    html.setAttribute("style", "overflow-y: scroll;position:unset;");
  });

  const modalSizeGuide = $('#size-guidelines-modal');
  if (modalSizeGuide.length) {
    modalSizeGuide.addClass('new-pdp-size-guidelines');
  }

  $('body').on('click', '#size-guidelines-modal.is-open .icon--close-mini-icon', () => {
    setTimeout(() => {
      document.getElementById('size-guidelines-modal').classList.remove('is-open');
    }, 50);
  });

  $('body').on('click', (e) => {
    if (e.target.classList.contains('pdp-popup-close')) {
      setTimeout(() => {
        document.getElementById('size-guidelines-modal').classList.remove('is-open');
      }, 50);
      
      if (e.target.dataset.dismiss) {
        let parent = $(e.target).parents('.dropdown');

        if(parent && parent.hasClass('is-open')) {

          $('body')[0].style['overflow-y'] = 'visible';
          $('body')[0].style['position'] = 'unset';
          $('body')[0].style['top'] = '0';
         
          parent.addClass('animate-minicart-closure').removeClass('is-open');
       
          setTimeout(() => {
            parent.removeClass('animate-minicart-closure');
            $('body').removeClass('no-zindex');
          }, 500);
        }
        
      }
      
    }
  });
});

$(document).on('DOMNodeInserted', function(e) {
  if($(e.target).hasClass('paypal-checkout-sandbox')){
    if(!document.activeElement.parentElement.parentElement.classList.contains('paypal-cart-button-minicart')){
        fastCheckout('paypal', 'shoppingbag');
    }
  }
});

$('body').on('click', '.apple-pay-cart-button', function() {
  fastCheckout('applepay', 'shoppingbag');
});


function fastCheckout(cartType, buttonPosition) {
  var fastCheckoutUrl = $(".track-fast-checkout-url").val();
  var fastCheckoutData = cartType + '_fast_' + buttonPosition;
  if(fastCheckoutUrl) {
    $.ajax({
      url: fastCheckoutUrl,
      method: 'GET',
      dataType: 'json',
      data: { fastPayment: fastCheckoutData},
      success: function (data) {
        $('body').trigger('checkout:fastCheckoutStart', [cartType, buttonPosition]);
      }
  });
 }

}

window.onload = function() {
  if ($('.coupon-price-adjustment').length > 0) {
    $('.voucher-input-container').addClass('input-d-none');
  }
};


$('body').on('click', '.cart-checkout-buttons-wrapper .checkout-btn', function() {
  var fastCheckoutUrl = $('.remove-track-fast-checkout-url').val();
  if(fastCheckoutUrl) {
    $.ajax({
      url: fastCheckoutUrl,
      method: 'GET',
      dataType: 'json',
      success: function (data) {
        $('.remove-track-fast-checkout-url').data('fastcheckout', false);
      }
  });
 }
});
